export default __webpack_public_path__ + "static/media/ex-profile.463cecf7.jpg";